export default {
    getCliente: state => state.cliente,
    getDatetime: state => state.datetime,
    getExpiration: state => state.expiration,
    getLoading: (state) => (local) => !!state.loading.find(l => l === local),
    getModulos: (state) => state.modulos,
    getNotification: state => state.notification,
    getSidebar: state => state.sidebar,
    getToken: state => state.token,
    getUsuario: (state) => state.usuario,
}